import React from 'react'
import { Ordering } from 'storfox-filter'

import { AUTOMATION_COLUMNS as tableColumns } from './AutomationRuleTable'

import { FILTER_NAME as name } from '../../../constants/AutomationRule'

export const automationOrderingOptions = {
  name,
  tableColumns
}

function AutomationOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default AutomationOrderingForm
